import { SVGProps } from 'react';
const SvgIconAlarmBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.81549 13.7773C6.89076 14.0337 7.04705 14.2589 7.26097 14.419C7.47489 14.5792 7.73493 14.6657 8.00216 14.6657C8.26938 14.6657 8.52942 14.5792 8.74334 14.419C8.95726 14.2589 9.11355 14.0337 9.18882 13.7773"
      stroke="#10111A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.54167}
    />
    <path
      d="M8 2.66634V1.33301"
      stroke="#10111A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.54167}
    />
    <path
      d="M8.00002 2.66602C9.17876 2.66602 10.3092 3.13427 11.1427 3.96776C11.9762 4.80126 12.4445 5.93172 12.4445 7.11046C12.4445 11.2859 13.3334 11.9993 13.3334 11.9993H2.66669C2.66669 11.9993 3.55558 10.8639 3.55558 7.11046C3.55558 5.93172 4.02383 4.80126 4.85732 3.96776C5.69082 3.13427 6.82128 2.66602 8.00002 2.66602Z"
      stroke="#10111A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.54167}
    />
  </svg>
);
export default SvgIconAlarmBell;
